import { render } from "./reviuPAPBJ.vue?vue&type=template&id=6ec23172"
import script from "./reviuPAPBJ.vue?vue&type=script&lang=js"
export * from "./reviuPAPBJ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__